// startDate/endDate are "YYYY-MM-DD" strings from <input type="date">
export function formatDateRange(startDate, endDate) {
  if (!startDate) return "";
  const start = new Date(startDate + "T00:00:00");
  if (!endDate || endDate === startDate) {
    return start.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  }
  const end = new Date(endDate + "T00:00:00");
  const sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
  if (sameMonth) {
    return `${start.toLocaleDateString(undefined, { month: "short" })} ${start.getDate()}–${end.getDate()}, ${end.getFullYear()}`;
  }
  return `${start.toLocaleDateString(undefined, { month: "short", day: "numeric" })} – ${end.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}`;
}

// date is "YYYY-MM-DD", time is "HH:MM" (both straight from their <input> types) — either
// may be absent (admin filled in only one of the pair).
export function formatDayTime(date, time) {
  const dayStr = date
    ? new Date(date + "T00:00:00").toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })
    : "";
  let timeStr = "";
  if (time) {
    const [h, m] = time.split(":").map(Number);
    timeStr = new Date(2000, 0, 1, h, m).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  }
  return [dayStr, timeStr].filter(Boolean).join(" • ");
}
